import cn from 'classnames';
import React from 'react';
import { AnswerState } from 'schema/src/types/state.generated';
import { inIframe } from '../../../../utils/location';
import { ContentWrapper } from '../ContentWrapper';
import styles from './GroupQuestionWrapper.module.css';

interface NewGroupQuestionWrapperProps {
  children: React.ReactNode;
  isLast: boolean;
  isFirstPollQuestion: boolean;
  withoutTitle: boolean;
  withoutQuestionText: boolean;
  answerState?: AnswerState;
}

export const GroupQuestionWrapper = ({
  children,
  isFirstPollQuestion,
  isLast,
  withoutTitle,
  withoutQuestionText,
}: NewGroupQuestionWrapperProps) => {
  const { divider, borders } = (() => {
    if (isFirstPollQuestion && isLast && withoutTitle) {
      return { divider: 'none', borders: 'all' } as const;
    }

    if (isFirstPollQuestion && withoutTitle) {
      return { divider: 'none', borders: 'top' } as const;
    }

    return { divider: 'top', borders: isLast ? 'bottom' : 'none' } as const;
  })();

  return (
    <ContentWrapper divider={divider} borders={borders}>
      <div
        className={cn({
          [c(styles.withSpacing)]: inIframe() && !isFirstPollQuestion,
          [c(styles.withoutQuestionText)]: inIframe() && withoutQuestionText,
        })}
      >
        {children}
      </div>
    </ContentWrapper>
  );
};
